import React from "react";
import styled from "styled-components";
import Loader from "react-loader-spinner";

const LoaderWrapper = styled.div`
  width: 100%;
  ${(props) => (props.$fullPage ? "height: 100vh;" : "min-height: 180px;")}
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  box-sizing: border-box;

  .loader {
    display: inline-block;
    margin-right: 10px;
  }
`;

function LoaderComponent({ text = "Please Wait", fullPage = false }) {
  return (
    <LoaderWrapper $fullPage={fullPage}>
      <div>
        <Loader
          type="TailSpin"
          color="#000"
          height="20"
          width="20"
          className="loader"
        />
        {text}
      </div>
    </LoaderWrapper>
  );
}

export default LoaderComponent;
